import { render, staticRenderFns } from "./OffersTable.vue?vue&type=template&id=3686ede8"
import script from "./OffersTable.vue?vue&type=script&setup=true&lang=js"
export * from "./OffersTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports